import { render, staticRenderFns } from "./AccountRail.vue?vue&type=template&id=f52fd6e8&scoped=true&"
import script from "./AccountRail.vue?vue&type=script&lang=js&"
export * from "./AccountRail.vue?vue&type=script&lang=js&"
import style0 from "./AccountRail.vue?vue&type=style&index=0&id=f52fd6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52fd6e8",
  null
  
)

export default component.exports